export default "__VITE_ASSET__9fd4c08a__"